<!--
vInput 组件支持 input 原生事件、支持v-model 指令
props字段：
max:输入最大长度 默认50
vClass：自定义样式类 默认 空
errText：错误提示语 默认 空
showLimit：是否显示最大长度 默认 false
labelName 默认 空
disabled: 是否不可填 默认 false
required： 是否显示 * 默认 false
type:[text|password]
reg:phone|email 默认 phone，给手机发送验证码,正则手机；email给邮箱发code ，正则邮箱
---
icon 插槽
name="v-left" //显示左iconfont
name="v-right" //显示左iconfont
例子：
<span slot="v-left" class="iconfont iconact_dianzan_full"></span>
<span slot="v-right" class="iconfont iconact_dianzan_full"></span>
-------
例子：
<v-input vClass="aa" v-model="val" required=true @input="vInput" @change="vChange" @blur="vBlur" :errText="'sdfsdf'" :showLimit="true" labelName="姓名" :disabled="false"></v-input>
-->

<template>
  <div :class="['v-input-box', vClass]">
    <label class="pointer">
      <div class="font-size-14 label">
        <span class="v-input-xing font-size-16" v-if="required">*</span><span v-if="labelName" class="v-label-color">{{
    labelName }}</span>
      </div>
      <div :class="['v-box', { 'err-border': errText }, disabled ? 'disabled' : '']">
        <slot name="v-left"></slot>
        <el-tooltip content="Top center" placement="top" :manual="true" v-model="show" :hideAfter="1000">
          <!-- <el-popover placement="top"> -->
          <input :type="type" :placeholder="placeholder || defaultHolder" :maxlength="max" v-model="val" @input="eInput"
            @blur="eBlur" @change="eChange" @focus="eFocus" :disabled="disabled" />
          <!-- </el-popover> -->
        </el-tooltip>
        <slot name="v-right">
          <span class="v-code-r theme-color font-size-14" :class="codeDisabled ? 'pointerNone' : 'pointerAuto'"
            v-if="isStart" @click="sendCode">{{ getCode }}</span>
          <span class="v-code-r theme-color font-size-14" v-if="!isStart">{{ getCode }}</span>
        </slot>
        <span class="font-size-12 v-limit" v-if="showLimit">{{ valLength }}/{{ max }}</span>
      </div>
    </label>
    <div class="v-input-err font-size-12">
      {{ errText }}
    </div>
  </div>
</template>
<script>
import { reg } from '@/utils/function'
export default {
  props: {
    seconds: {
      type: [Number],
      default: () => 60
    },
    labelName: {
      type: [String],
      default: () => ''
    },
    type: {
      type: [String],
      default: () => 'text'
    },
    required: {
      type: [Boolean],
      default: () => false
    },
    max: {
      type: [Number],
      default: () => 50
    },
    errText: {
      type: [String],
      default: () => ''
    },
    tip: {
      type: [String],
      default: () => ''
    },
    vClass: {
      type: [String],
      default: () => ''
    },
    showLimit: {
      type: [Boolean],
      default: () => false
    },
    disabled: {
      type: [Boolean],
      default: () => false
    },
    reg: {
      type: [String],
      default: () => 'phone'
    },
    regText: {
      type: [String],
      default: () => ''
    },
    value: {
      type: [String, Number, Object],
      default: () => ''
    },
    placeholder: {
      type: [String],
      default: () => ''
    },
    stop: {
      type: [Boolean],
      default: () => false
    },
    language: {
      type: [String],
      default: () => ''
    }
  },
  name: 'codes',
  components: {},
  computed: {
    valLength() {
      return this.val.length
    }
  },
  data() {
    return {
      codeDisabled: false,
      val: this.value,
      phoneOrEmail: this.regText,
      getCode: this.$t('getCode'),
      getCodeText: this.$t('getCode'),
      isStart: true,
      show: false,
      timer: null,
      defaultHolder:
        localStorage.getItem('language') == 'en'
          ? this.$t('placeholder') + ' ' + this.labelName.toLowerCase()
          : this.$t('placeholder') + this.labelName
    }
  },
  watch: {
    stop() {
      if (this.stop) {
        this.rest()
      }
    },
    regText() {
      this.phoneOrEmail = this.regText
    }
  },
  methods: {
    rest() {
      this.getCode = this.getCodeText
      this.isStart = true
      this.codeDisabled = false
      clearInterval(this.timer)
      this.timer = null

      // 清理可能存在的验证码定时器
      if (this._codeTimer) {
        clearTimeout(this._codeTimer)
        this._codeTimer = null
      }
    },
    sendCode() {
      this.codeDisabled = true
      let _this = this
      if (_this.disabled) {
        return ''
      }

      // 清除之前的定时器（防抖）
      if (this._codeTimer) {
        clearTimeout(this._codeTimer)
      }

      // 设置新的定时器
      this._codeTimer = setTimeout(() => {
        _this.getCodeFun()
      }, 300)
    },
    getCodeFun() {
      var val = this.phoneOrEmail
      if (this.reg == 'phone') {
        //正则 手机号
        if (!val) {
          this.$notify.error({
            message: this.$t('Please enter your moblie')
          })
          this.codeDisabled = false
          return ''
        } else if (!reg.chinesePhone.test(val)) {
          this.$notify.error({
            message: this.$t('Please enter your correct mobile')
          })
          this.codeDisabled = false
          return ''
        } else if (!reg.chinesePhone.test(val) && this.language == 'zh') {
          this.$notify.error({
            message: this.$t('Please enter your correct mobile')
          })
          this.codeDisabled = false
          return ''
        }
      } else {
        //正则邮箱
        if (!val) {
          this.$notify.error({
            message: this.$t('Please enter your email')
          })
          this.codeDisabled = false
          return ''
        } else if (!reg.email.test(val)) {
          this.$notify.error({
            message: this.$t('Please enter your correct email address')
          })
          this.codeDisabled = false
          return ''
        }
      }
      this.$emit('callback', { type: 'sendCode', reg: this.reg })
      /**
       * 发送验证码前可能存在 是否发送验证码 的判断 
       * 当由 1 => 2 时 触发秒表
       * 当由 1 => 3 时 不触发秒表
       * 1 => 等待中
       * 2 => 发送验证码
       * 3 => 不发生验证码
       */
      let codeAwait = sessionStorage.getItem('codeAwait')
      if (codeAwait === '1') {
        let timer = setInterval(() => {
          codeAwait = sessionStorage.getItem('codeAwait')
          if (codeAwait === '2' || codeAwait === '3') {
            clearInterval(timer)
            sessionStorage.removeItem('codeAwait')
            timer = null
          }
          if (codeAwait === '2') {
            this.startCountDown(this.reg)
          } else if (codeAwait === '3') {
            this.rest()
          }
        }, 100)
      } else {
        sessionStorage.removeItem('codeAwait')
        this.startCountDown(this.reg)
      }
    },
    startCountDown(type) {
      var s
      if (type == 'email') {
        s = 299
      } else {
        s = 59
      }
      s = this.seconds
      var _this = this
      _this.isStart = false
      _this.getCode = s + 's'
      s--
      _this.timer = setInterval(() => {
        if (s < 0) {
          _this.rest()
        } else {
          _this.getCode = s + 's'
          s--
        }
      }, 1000)
    },
    eInput() {
      var _this = this
      _this.$emit('input', _this.val.trim())
    },
    eBlur() {
      this.$emit('blur', this.val.trim())
    },
    eChange() {
      this.$emit('change', this.val.trim())
    },
    eFocus() {
      this.$emit('focus', this.val.trim())
    }
  },
  created() { },
  beforeDestroy() {
    // 组件销毁前清理所有定时器
    if (this.timer) {
      clearInterval(this.timer)
    }

    if (this._codeTimer) {
      clearTimeout(this._codeTimer)
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-input-box{
    margin:12px 0;
    .pointerNone{
      pointer-events:none;
    }
    .pointerAuto{
      pointer-events:auto;
    }
    .disabled{
      background-color:$color-input-bg-code1;
      border-color:$color-input-border1;
      color:$color-input-color1;
      cursor: not-allowed;
      input{
        background-color:$color-input-bg-code1;
        border-color:$color-input-border1;
        color:$color-input-color1;
        cursor: not-allowed;
        max-width:140px;
        font-size: 14px;
      }
      .v-code-r{
        color:$color-input-color1;
      }
    }
    input{
        outline:none;
        height:100%;
        min-height:30px;
        padding:0 8px;
        border:0;
        max-width: 180px;
        font-size: 14px;
    }
    .err-border{
        border:1px solid red;
    }
    .v-input-xing{
        color:red;
        vertical-align:middle;
        margin-right :5px;
    }
    .v-input-err{
        color:red;
    }
    .label{
        line-height 20px;
        margin-bottom :8px;
    }
    .v-limit{
        margin-left:5px;
    }
    .v-box{
        display:inline-block;
        border: 1px solid $color-black-15;
        padding: 0 5px;
        width:100%;
        border-radius: 5px;
        .iconfont{
            margin:0;
            vertical-align: middle;
        }
    }
    .v-label-color{
      color:$color-black-65;
    }
    ::placeholder{
      color:$color-black-25;
    }
    .v-code-r{
        float: right;
        padding-right: 3px;
        height: 30px;
        line-height:30px;
        font-size: 13px;
    }
}
</style>
